import { RESET_AUTHENTICATION, SET_AUTHENTICATION } from 'services/redux/action-types'
import { authenticationConstants } from "services/redux/authentication/constants";

const initialState = {
	[authenticationConstants.LOGGED_IN]: null,
	[authenticationConstants.TOKEN_REVALIDATE]: null,
};

export default function data( state = initialState, action ) {
	switch (action.type) {
		case SET_AUTHENTICATION:
			return {
				...state,
				[action.key]: action.payload
			};

		case RESET_AUTHENTICATION:
			return false;
			
		default:
			// Nothing
	}
	
	return state;
}
